const merchantMenus = [
    {
        code: "ai-creation",
        name: "AI 创作",
        category: "ai",
        menus: [
            {
                "name": "AI 创作",
                "title": "AI 创作",
                "code": "ai.pic.view",
                "icon": "MagicStick",
                "children": []
            }
        ]
    },
    {
        code: "my-merchant-share",
        name: "分享增长",
        category: "merchantShare",
        menus: [
            {
                "name": "分享增长",
                "title": "分享增长",
                "code": "merchant.share.view",
                "icon": "School",
                "children": [
                    {
                        "name": "海报二维码",
                        "link": "/l/merchant/posterQrcode",
                        "code": "merchant.poster.qrcode.view",
                        "icon": "Folder"
                    }
                ]
            }
        ]
    },
    {
        code: "my-institution",
        name: "我的机构",
        category: "merchant",
        menus: [
            {
                "name": "我的机构",
                "title": "我的机构",
                "code": "merchant",
                "icon": "School",
                "subtitle": "管理机构基础资料",
                "children": [
                    {
                        "name": "机构资料",
                        "link": "/l/merchant/merchantInfo",
                        "code": "merchant.view",
                        "icon": "Folder"
                    },
                    {
                        "name": "师资管理",
                        "link": "/l/merchant/teacher",
                        "code": "teacher.view",
                        "icon": "Avatar"
                    },
                    {
                        "name": "课程管理",
                        "link": "/l/merchant/goods",
                        "code": "goods.view",
                        "icon": "Notebook"
                    },
                    {
                        "name": "机构荣誉",
                        "link": "/l/merchant/honor",
                        "code": "honor.view",
                        "icon": "Trophy"
                    },

                    {
                        "name": "学员颁奖",
                        "link": "/l/merchant/studentHonor",
                        "code": "student.honor.view",
                        "icon": "Medal"
                    }
                ]
            }
        ]
    }
]

export default merchantMenus
